import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import DeleteIcon from "@mui/icons-material/Delete";
import CameraIcon from "@mui/icons-material/Camera";
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import { Typography, Box } from "@mui/material";
import ConfirmDialog from "./../../../ConfirmDialog";
import ResponsiveButton from "../../../Forms/ResponsiveButton";
import { timeToLocale } from "../../../../utils/timeConversion";
import AutoSave from "./AutoSave";
import { Form } from "react-final-form";
import TrayFields from "./TrayFields";
import ResponsiveIconButton from "../../../Forms/ResponsiveIconButton";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PreviousNextContainer from "./PreviousNextContainer/index.js";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import TrayImageContainer from './imageContainer.js'


const TrayViewer = ({
  handleRetakeTray,
  handleDeleteTray,
  handleCaptureOtherSide,
  handleSwitchImage,
  disableSwitchButton,
  disableCaptureOtherSide,
  handleFinish,
  disableRetakeSide,
  trapSites,
  trayId,
  trayDisplayName,
  trayCaptureTimeStamp,
  specimens,
  traySideMsg,
  specimenOnDisplay,
  loading,
  trayImage,
  handleChangeMetadata,
  metadataErrorDialogOpts,
  trapTypeAutoCompleteOptions,
  disableFinish,
  pathname,
  handleSpecimenJump,
  timeZone,
  metadata,
  tagsOptions,
  trayValid,
  setSavedHistoryCaptureBothSide,
  setCaptureBothSideModal,
  otherSideDone,
  isTrayAutoPopulate,
  handleIsTrayAutoPopulateCheck,
  handleCaptureNewTray,
  isEnableCaptureNewTray,
}) => {
  const [showRetakeConfirm, setShowRetakeConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const hiddenViewElement = pathname === "/details/tray/capture" ? false : true;
  const headerButtonStyle = {
    background: "rgba(218, 244, 254, 0.1)",
  };

  const phraseTimestamp = (trayCaptureTimeStamp) => {
    let customFormat = "M/DD/YYYY, h:mm:ss A z";
    return timeToLocale(trayCaptureTimeStamp, { timeZone, customFormat });
  };

  useEffect(() => {
    console.log(isEnableCaptureNewTray, otherSideDone)
  }, [isEnableCaptureNewTray, otherSideDone])

  return (
    <Form
      style={{ marginTop: "50px", with: "100%" }}
      onSubmit={() => { }}
      mutators={{
        setValue: ([field, value], state, { changeValue }) => {
          changeValue(state, field, () => value);
        },
      }}
      initialValues={metadata}
      validate={(values) => {
        const errors = {};
        return errors;
      }}
      render={(form) => (
        <div id={"tray-details"}>
          <AutoSave
            debounce={0}
            trayId={trayId}
            save={(value) => {
              let isChanged = value?.id ? false : true;
              handleChangeMetadata(value, isChanged);
            }}
          />
          <Box id={"capture-tray"} style={{
            width: '100%',
            height: "100vh",
            backgroundColor: "white",
            borderLeft: '.5px solid rgba(0, 0, 0, 0.2)',
          }}>
            <form id={"trap-info-form"}>
              <div style={{
                backgroundColor: "white",
                paddingTop: "2rem", paddingLeft: "2rem", paddingRight: "2rem",
                height: "100vh",
                maxWidth: "1200px",
                margin: "auto"
              }}
                id={"tray-header"}>
                <div >
                  <div
                    id={"tray-inputs"}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '100%',
                        height: '100%',
                      }}>
                      <ResponsiveButton
                        id={"upload-tray-metadata"}
                        disabled={hasValidationErrors || disableFinish}
                        onClick={() => handleFinish()}
                        sx={{
                          marginTop: '-25px', marginRight: '-10px', fontSize: '20px', border: "1px solid #D3D3D3",
                        }}
                      >
                        <Tooltip title={`Close Tray`}
                          PopperProps={{
                            sx: {
                              '& .MuiTooltip-tooltip': {
                                fontSize: '15px', // Increase font size directly
                              },
                            },
                          }}
                        >
                          <CloseIcon style={{ color: '#167bc3' }} />
                        </Tooltip>
                      </ResponsiveButton>
                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "15px",
                          color: "#167bc3",
                          marginTop: '8px'
                        }}
                      >
                        {trayDisplayName}
                        {traySideMsg.toUpperCase()}
                      </Typography>
                      <ResponsiveIconButton
                        onClick={() => handleIsTrayAutoPopulateCheck(isTrayAutoPopulate)}
                        // disabled={ }

                        id={"btn-auto-fill-prev-tray-Data"}
                        style={{
                          visibility: "visible",
                          display: "block",
                          border: "0.5px solid",
                          marginLeft: ".5rem"
                        }}
                      >
                        Auto-fill Prev Tray Data
                        {isTrayAutoPopulate ? <CheckBoxIcon /> :
                          <CheckBoxOutlineBlankIcon />}
                      </ResponsiveIconButton>

                      <div
                        id={"switch-tray-side"}
                        style={{
                          display: "flex",
                          // marginRight: "10px",
                          justifyContent: "flex-end",
                          marginLeft: "auto",
                        }}
                      >
                        <ResponsiveButton
                          sx={{
                            border: "0.5px solid",
                          }}
                          onClick={() => setShowRetakeConfirm(true)}
                          disabled={disableRetakeSide}
                          style={{
                            visibility: hiddenViewElement ? "hidden" : "visible",
                            display: hiddenViewElement ? "none" : "block",
                            marginLeft: ".5rem"
                          }}
                        >
                          Retake
                          <AutorenewIcon />
                        </ResponsiveButton>
                        <ResponsiveButton
                          sx={{
                            border: "0.5px solid ",
                            marginLeft: '5px',
                          }}
                          onClick={handleCaptureOtherSide}
                          disabled={disableCaptureOtherSide}
                          id={"capture-other-side"}
                          style={{
                            visibility: hiddenViewElement ? "hidden" : "visible",
                            display: hiddenViewElement ? "none" : "block",
                            background: isEnableCaptureNewTray ? (otherSideDone ? '' : '#167bc3') : "",
                            color: isEnableCaptureNewTray ? (otherSideDone ? '' : 'white') : ""
                          }}
                        >
                          CAPTURE OTHER SIDE
                          <CameraIcon className={"mr-1"} />
                        </ResponsiveButton>

                        <ResponsiveButton
                          variant="outlined"
                          style={{
                            ...headerButtonStyle,
                            backgroundColor: "white",
                            marginLeft: "5px",
                          }}
                          onClick={handleSwitchImage}
                          disabled={loading || disableSwitchButton}
                          sx={{
                            display: disableSwitchButton ? "block" : "block",
                          }}
                        >
                          <Tooltip
                            title={`Flip Tray`}
                            PopperProps={{
                              sx: {
                                '& .MuiTooltip-tooltip': {
                                  fontSize: '15px', // Increase font size directly
                                },
                              },
                            }}
                          >
                            <>
                              FLIP
                              <SwapHorizIcon />
                            </>
                          </Tooltip>
                        </ResponsiveButton>
                        <ResponsiveButton
                          onClick={() => handleCaptureNewTray()}
                          disabled={!isEnableCaptureNewTray}
                          id={"capture-other-side"}
                          style={isEnableCaptureNewTray && (hiddenViewElement ? true : otherSideDone) ? {
                            background: "#167bc3",
                            color: "white"
                          } : {}}
                          sx={{
                            visibility: "visible",
                            display: "block",
                            border: "0.5px solid ",
                            marginLeft: '5px',
                          }}
                        >
                          Capture new Tray
                        </ResponsiveButton>
                      </div>
                    </div>

                    <TrayFields
                      form={form}
                      trapTypeAutoCompleteOptions={trapTypeAutoCompleteOptions}
                      loading={loading} trapSites={trapSites}
                      trayId={trayId}
                      tagsOptions={tagsOptions}
                      setHasValidationErrors={setHasValidationErrors}
                    />
                    {/* TRAY IMAGE  */}
                    <div
                      className={"flex relative flex-1"}
                      id={"tray-image"}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: ".5rem",
                        marginLeft: "0",
                        width: '100%',
                        borderTop: "black 1px #e2e8f0"
                      }}>
                    </div>
                  </div>
                  <PreviousNextContainer
                    trayValid={trayValid}
                    setSavedHistoryCaptureBothSide={setSavedHistoryCaptureBothSide}
                    setCaptureBothSideModal={setCaptureBothSideModal}
                    otherSideDone={otherSideDone}
                  >
                    <TrayImageContainer
                      specimens={specimens}
                      specimenOnDisplay={specimenOnDisplay}
                      trayImage={trayImage}
                      handleSpecimenJump={handleSpecimenJump}
                    />
                  </PreviousNextContainer>
                  <div
                    id={"trap-info"}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: '1rem',
                      marginBottom: ".25rem",
                    }}
                  >
                    <Typography
                      className={"text-gray-600"}
                      sx={{
                        fontSize: '1rem'
                      }}
                    >
                      Imaging Time:{" "}
                      {trayCaptureTimeStamp !== "" &&
                        phraseTimestamp(trayCaptureTimeStamp)}
                    </Typography>
                    <ResponsiveButton
                      onClick={() => setShowDeleteConfirm(true)}
                      disabled={loading}
                      id={"delete-tray"}
                      sx={{
                        color: "status.danger",
                        marginTop: "-.5rem"
                      }}
                    >
                      <DeleteIcon />
                      &nbsp;&nbsp;
                      <Typography sx={{
                        color: "red",
                        fontSize: '.875rem'
                      }}>
                        DELETE IMAGE
                      </Typography>
                      {/* </Tooltip> */}
                    </ResponsiveButton>
                  </div>
                  <ConfirmDialog
                    title={"Delete tray?"}
                    children={
                      "All tray data will be deleted, including its specimens data and images"
                    }
                    open={showDeleteConfirm}
                    setOpen={setShowDeleteConfirm}
                    onConfirm={handleDeleteTray}
                    id={"delete-tray-confirm-dialog"}
                  />
                  <ConfirmDialog
                    {...metadataErrorDialogOpts}
                    title={"You may still have unsaved changes"}
                    children={"Continue anyway?"}
                    id={"metadata-error-confirm-dialog"}
                  />
                  <ConfirmDialog
                    title={"Retake tray image?"}
                    children={
                      "The new image will overwrite the current image. Make sure the tray is in the same orientation."
                    }
                    open={showRetakeConfirm}
                    setOpen={setShowRetakeConfirm}
                    onConfirm={handleRetakeTray}
                    id={"retake-tray-confirm-dialog"}
                  />
                </div>
              </div>
            </form>
          </Box>
        </div >
      )}
    ></Form >
  );
};

export default connect()(TrayViewer);
